module.exports = __webpack_public_path__ + "media/images/area-badges/food-security-production-9b1c392b5da9a5dcbef13121b12b61e4.svg";